import { useCallback, useRef, useState } from "react";
import { api } from "@/lib/leuteliaApi";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Loader2, Wallet } from "lucide-react";

const eur = (v) => `${(v || 0).toFixed(2).replace(".", ",")} $`;

export function usePreventivo() {
  const [state, setState] = useState(null);
  const resolver = useRef(null);
  const confirm = useCallback(async (params) => {
    setState({ loading: true, params });
    try { const est = await api.estimate(params); setState({ est, params }); }
    catch (e) { setState({ error: e.message, params }); }
    return new Promise((resolve) => { resolver.current = resolve; });
  }, []);
  const close = (ok) => { setState(null); resolver.current?.(ok); resolver.current = null; };
  const dialog = (
    <AlertDialog open={!!state} onOpenChange={(o) => { if (!o) close(false); }}>
      <AlertDialogContent data-testid="preventivo-dialog" className="max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-serif text-[22px] flex items-center gap-2"><Wallet size={18} className="text-brand-gold" /> Preventivo prima di spendere</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-[13px] text-brand-ink space-y-3">
              {state?.loading && <div className="flex items-center gap-2 text-brand-muted"><Loader2 size={14} className="animate-spin" /> calcolo il costo stimato…</div>}
              {state?.error && <div className="text-brand-maroon">Stima non disponibile: {state.error}</div>}
              {state?.est && (
                <>
                  <div className="rounded-lg border border-brand-gold/25 bg-brand-cream/60 p-3">
                    <div className="text-[11px] uppercase tracking-[0.14em] text-brand-muted">Costo stimato di questa prova</div>
                    <div className="font-serif text-[30px] text-brand-ink leading-none mt-1" data-testid="preventivo-totale">{eur(state.est.usd)}</div>
                    <div className="text-[12px] text-brand-muted mt-1">tra {eur(state.est.usd_low)} e {eur(state.est.usd_high)} · circa {state.est.minutes} minuti · oggi già spesi {eur(state.est.today_usd)} su {eur(state.est.cap_usd)}</div>
                  </div>
                  <ul className="space-y-1">{state.est.rows.map((r, i) => <li key={i} className="flex justify-between gap-3 text-[12.5px]"><span className="text-brand-ink">{r.n} × {r.label}</span><span className="text-brand-muted whitespace-nowrap">{eur(r.usd)}</span></li>)}</ul>
                  <p className="text-[11.5px] text-brand-muted">{state.est.note}</p>
                </>
              )}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="preventivo-annulla" onClick={() => close(false)}>Annulla, non spendere</AlertDialogCancel>
          <AlertDialogAction data-testid="preventivo-conferma" disabled={!state?.est} onClick={() => close(true)} className="bg-brand-green hover:bg-brand-greenDark text-brand-cream">Confermo, avvia</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
  return { confirm, dialog };
}
